<template>
    <component :is="content"></component>
</template>

<script>
  import { isPC } from "@/utils";
  import  Home  from "@/components/Home"
  import  MobileHome  from "@/components/MobileHome"

  export default {
        name: "MiddleHome",
        data() {
          return {
            content: 'Home'
          }
        },
        components: {
          Home,
          MobileHome
        },
        created() {
          if (!isPC()) {
            this.content = 'MobileHome';
          }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/middle/MiddleHome.vue